const GET_BRACKET_ACTUALS = `
query MyQuery($missionID: ID = "10") {
  getBracketActuals(missionID: $missionID)
}
`;

export default GET_BRACKET_ACTUALS;
